import { Component, OnInit, Input, Inject } from '@angular/core';
import { LoadConfigService } from '../../services/load-config.service';
import { StudyNavigationService } from '../../services/study-navigation.service';
import { InstructionService } from '../../services/instruction.service';

@Component({
  selector: 'app-image-full',
  templateUrl: './image-full.component.html',
  styleUrls: ['./image-full.component.scss'],
})
export class ImageFullComponent implements OnInit {
  @Input('instruction') instruction: string;
  @Input('section') section: string;
  @Input('label') label: string;
  @Input('isPractice') isPractice: boolean = true;
  baseImgUrl: string = '/assets/images';

  imageToShow: string = null;

  constructor(
    private navigationService: StudyNavigationService,
    private instructionService: InstructionService,
    @Inject('BASE_URL') private baseUrl: string
  ) {}

  ngOnInit(): void {
    this.baseImgUrl = `${this.baseUrl}assets/images`;

    const instructionInfo = this.instructionService.getInstructions('EN')[
      this.instruction
    ];

    if (!this.label) {
      this.label = this.instructionService.getTranslationsForTerm(
        'MEDIA_CONTINUE_BUTTON'
      );
    }

    const { brandImage } = this.navigationService.getBrandImage(
      this.isPractice ? 'practice' : 'IAT'
    );

    if (brandImage) {
      this.imageToShow = `${this.baseImgUrl}/${brandImage}`;
    } else if (instructionInfo.hasOwnProperty('image')) {
      this.imageToShow = `${this.baseImgUrl}/${instructionInfo['image']}`;
    } else {
      this.imageToShow = `${this.baseImgUrl}/brand_practice.jpeg`;
    }
  }
}
